module.exports = __webpack_public_path__ + "img/main_bg4.91679b1.webp";